function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "welcome_svg__a",
  x1: 0.5,
  x2: 0.5,
  y1: 0.993,
  y2: -0.06
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c2e1fe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#259aff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("style", null, ".welcome_svg__welcome-cls-1{opacity:.25;fill:url(#welcome_svg__a)}.welcome_svg__welcome-cls-2{fill:#ffb304}.welcome_svg__welcome-cls-4{fill:#ff9406}.welcome_svg__welcome-cls-5{fill:#ef8506}.welcome_svg__welcome-cls-6{fill:#202cb9}.welcome_svg__welcome-cls-15,.welcome_svg__welcome-cls-7{fill:#c2e1fe}.welcome_svg__welcome-cls-8,.welcome_svg__welcome-cls-9{fill:#003aa5}.welcome_svg__welcome-cls-15,.welcome_svg__welcome-cls-8{mix-blend-mode:multiply;isolation:isolate}.welcome_svg__welcome-cls-10{fill:#d32f09}.welcome_svg__welcome-cls-11{fill:#fff}.welcome_svg__welcome-cls-12{fill:#ebe4ea}.welcome_svg__welcome-cls-13{fill:#f53700}.welcome_svg__welcome-cls-14{fill:#e3f1fe}.welcome_svg__welcome-cls-18{fill:#259aff}.welcome_svg__welcome-cls-19{fill:#f9f9f9}.welcome_svg__welcome-cls-20{fill:#d82d05}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1786"
}, /*#__PURE__*/React.createElement("path", {
  d: "M461.9 202.643c-24.365-69.5-110.03-42.283-162.01-47.112-55.978-5.2-28.156-41.009-101.19-68.648-66.95-25.336-170.05 52.959-151.2 172.96 23.279 148.12 247.23 170.25 339.84 111.89 64.893-40.891 78.821-106.08 79.537-136a93.157 93.157 0 00-4.979-33.091z",
  className: "welcome_svg__welcome-cls-1",
  "data-name": "Path 1210"
}), /*#__PURE__*/React.createElement("path", {
  d: "M409.156 81.6a93.176 93.176 0 00-27.712-18.75c-67.633-29.144-105.63 52.317-144.39 87.288-41.739 37.661-51.107 11.09-122.63 42.439s-86.786 175.92 37.201 204.76c169.44 39.412 268.89-72.822 293.48-169.83 19.14-75.513-14.416-125.12-35.948-145.91z",
  className: "welcome_svg__welcome-cls-1",
  "data-name": "Path 1211"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1791"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1788"
}, /*#__PURE__*/React.createElement("path", {
  d: "M252.594 149.845l2.252.594 1.195.315 3.384.891s46.973-42.977 32.862-66.014c-4.343-7.092-16.1-5.92-21.214 18.987-4.745 23.087-18.479 45.227-18.479 45.227z",
  className: "welcome_svg__welcome-cls-2",
  "data-name": "Path 1212"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1787"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ea9e06",
  d: "M254.85 150.438l1.195.315c9.289-11.055 16.2-23.872 20.486-33.039a173.123 173.123 0 007.719-19.206.558.558 0 00-1.065-.335 172.616 172.616 0 01-7.679 19.085c-4.307 9.212-11.278 22.131-20.656 33.18z",
  "data-name": "Path 1213"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1790"
}, /*#__PURE__*/React.createElement("path", {
  d: "M244.42 159.194l2.534 1.983 1.345 1.051 3.808 2.979s83.078-28.905 77.742-65.846c-1.642-11.373-17.2-16.3-37.29 12.517-18.623 26.714-48.139 47.316-48.139 47.316z",
  className: "welcome_svg__welcome-cls-4",
  "data-name": "Path 1214"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1789"
}, /*#__PURE__*/React.createElement("path", {
  d: "M246.952 161.176l1.345 1.051c17.824-8.959 33.587-21.455 44.034-30.75a239.37 239.37 0 0020.288-20.159.771.771 0 00-1.168-1.007 238.3 238.3 0 01-20.165 20.03c-10.5 9.341-26.4 21.935-44.334 30.835z",
  className: "welcome_svg__welcome-cls-5",
  "data-name": "Path 1215"
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1796"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1793"
}, /*#__PURE__*/React.createElement("path", {
  d: "M114.691 251.763c10.289 14.844-3.924 13.366 3.577 24.528 6.838 10.173 20.768 4.006 16.111 24.98-1.019 4.588 1.722 8.626 6.121 11.238a18.271 18.271 0 0020.959-1.459c.458-.359.9-.742 1.324-1.146a18.608 18.608 0 005.465-17.516c-1.177-5.667-4.014-11.547-10.336-14.832-14.833-7.707-2.336-26.938-15.452-30.261-15.819-4.009-15.328-9.987-25.259-19.97-10.531-10.584-16.46 4.322-2.51 24.438z",
  className: "welcome_svg__welcome-cls-4",
  "data-name": "Path 1216"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1792"
}, /*#__PURE__*/React.createElement("path", {
  d: "M121.566 245.92c.286.426 23.978 35.76 39.888 65.129.458-.359.9-.742 1.324-1.146-15.965-29.395-39.507-64.511-39.795-64.937a.855.855 0 00-1.418.954z",
  className: "welcome_svg__welcome-cls-5",
  "data-name": "Path 1217"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1795"
}, /*#__PURE__*/React.createElement("path", {
  d: "M104.947 298.578c18.039 14.626-.038 17.91 13.233 28.993 12.1 10.1 27.078-2.52 28.868 25.045.392 6.03 5.228 10.03 11.6 11.673a23.494 23.494 0 0025.349-9.336c.436-.608.846-1.24 1.223-1.89a23.928 23.928 0 00.446-23.585c-3.489-6.573-9.106-12.811-18.091-14.6-21.082-4.182-12.566-32.416-29.953-31.8-20.968.738-22.511-6.819-38.36-15.573-16.801-9.279-18.761 11.252 5.685 31.073z",
  className: "welcome_svg__welcome-cls-2",
  "data-name": "Path 1218"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1794"
}, /*#__PURE__*/React.createElement("path", {
  d: "M111.344 288.89c.506.423 42.455 35.526 72.654 66.062.436-.608.846-1.24 1.223-1.89-30.274-30.549-71.961-65.437-72.469-65.859a1.1 1.1 0 00-1.407 1.687z",
  className: "welcome_svg__welcome-cls-4",
  "data-name": "Path 1219"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1797",
  transform: "translate(161.78 132.38)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 160.67,
  height: 235.79,
  className: "welcome_svg__welcome-cls-6",
  "data-name": "Rectangle 321",
  rx: 8.128
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.909 11.781h140.855v206.707H9.909z",
  className: "welcome_svg__welcome-cls-7",
  "data-name": "Rectangle 322"
}), /*#__PURE__*/React.createElement("rect", {
  width: 31.904,
  height: 2.704,
  className: "welcome_svg__welcome-cls-8",
  "data-name": "Rectangle 323",
  rx: 1.25,
  transform: "translate(64.385 3.965)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 33.009,
  height: 10.758,
  className: "welcome_svg__welcome-cls-8",
  "data-name": "Rectangle 324",
  rx: 4.974,
  transform: "translate(63.832 221.97)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1798"
}, /*#__PURE__*/React.createElement("path", {
  d: "M178.41 203.29l8.824-21.768h-22.98l-12.007 21.768z",
  className: "welcome_svg__welcome-cls-9",
  "data-name": "Path 1220"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1799"
}, /*#__PURE__*/React.createElement("path", {
  d: "M204.29 203.29l5.182-21.768h-22.233l-8.824 21.768z",
  className: "welcome_svg__welcome-cls-10",
  "data-name": "Path 1221"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1800"
}, /*#__PURE__*/React.createElement("path", {
  d: "M230.16 203.29l2.29-21.768h-22.983l-5.169 21.768z",
  className: "welcome_svg__welcome-cls-9",
  "data-name": "Path 1222"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1801"
}, /*#__PURE__*/React.createElement("path", {
  d: "M333.71 203.29l-11.388-21.768h-23.3l8.793 21.768z",
  className: "welcome_svg__welcome-cls-9",
  "data-name": "Path 1223"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1802"
}, /*#__PURE__*/React.createElement("path", {
  d: "M307.83 203.29l-8.734-21.768h-22.033l4.893 21.777z",
  className: "welcome_svg__welcome-cls-10",
  "data-name": "Path 1224"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1803"
}, /*#__PURE__*/React.createElement("path", {
  d: "M281.953 203.3l-4.893-21.777h-24.53l3.545 21.768z",
  className: "welcome_svg__welcome-cls-9",
  "data-name": "Path 1225"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1804"
}, /*#__PURE__*/React.createElement("path", {
  d: "M178.41 203.29l8.824-21.768h-22.98l-12.007 21.768z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1226"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1805"
}, /*#__PURE__*/React.createElement("path", {
  d: "M230.16 203.29l2.29-21.768h-22.983l-5.169 21.768z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1227"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1806"
}, /*#__PURE__*/React.createElement("path", {
  d: "M333.71 203.29l-11.388-21.768h-23.3l8.793 21.768z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1228"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1807"
}, /*#__PURE__*/React.createElement("path", {
  d: "M281.953 203.3l-4.893-21.777h-24.53l3.545 21.768z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1229"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1808"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256.07 203.29l-3.545-21.768h-20.1l-2.256 21.768z",
  className: "welcome_svg__welcome-cls-10",
  "data-name": "Path 1230"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1809"
}, /*#__PURE__*/React.createElement("path", {
  d: "M152.25 203.29h26.147v19.245a12.088 12.088 0 01-12.088 12.088h-1.97a12.088 12.088 0 01-12.089-12.088V203.29z",
  className: "welcome_svg__welcome-cls-12",
  "data-name": "Rectangle 325"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1810"
}, /*#__PURE__*/React.createElement("path", {
  d: "M191.355 234.622a12.938 12.938 0 01-12.938-12.938v-18.012a.384.384 0 01.384-.384h25.107a.384.384 0 01.384.384v18.012a12.938 12.938 0 01-12.937 12.938z",
  className: "welcome_svg__welcome-cls-13",
  "data-name": "Path 1231"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1811"
}, /*#__PURE__*/React.createElement("path", {
  d: "M243.13 234.622a12.938 12.938 0 01-12.938-12.938v-18.012a.384.384 0 01.383-.384h25.108a.384.384 0 01.383.384v18.012a12.937 12.937 0 01-12.936 12.938z",
  className: "welcome_svg__welcome-cls-13",
  "data-name": "Path 1232"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1812"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256.08 203.3h25.875v19.37a11.963 11.963 0 01-11.962 11.963h-1.95a11.963 11.963 0 01-11.963-11.963V203.3z",
  className: "welcome_svg__welcome-cls-12",
  "data-name": "Rectangle 326"
}));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1813"
}, /*#__PURE__*/React.createElement("path", {
  d: "M294.89 234.64a12.938 12.938 0 01-12.938-12.938V203.69a.384.384 0 01.384-.384h25.108a.384.384 0 01.383.384v18.012a12.938 12.938 0 01-12.937 12.938z",
  className: "welcome_svg__welcome-cls-13",
  "data-name": "Path 1233"
}));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1814"
}, /*#__PURE__*/React.createElement("path", {
  d: "M320.774 234.64a12.939 12.939 0 01-12.938-12.938V203.31h25.875v18.4a12.938 12.938 0 01-12.937 12.93z",
  className: "welcome_svg__welcome-cls-12",
  "data-name": "Path 1234"
}));

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M217.228 234.626a12.938 12.938 0 01-12.938-12.938v-18.4h25.873v18.4a12.938 12.938 0 01-12.935 12.938z",
  className: "welcome_svg__welcome-cls-12",
  "data-name": "Path 1235"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M176.96 242.4h130.319v21.464H176.96z",
  className: "welcome_svg__welcome-cls-14",
  "data-name": "Rectangle 327"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M218.38 269.8h88.899v6.805H218.38z",
  className: "welcome_svg__welcome-cls-14",
  "data-name": "Rectangle 328"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M218.38 280.53h88.899v6.805H218.38z",
  className: "welcome_svg__welcome-cls-14",
  "data-name": "Rectangle 329"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M218.38 291.27h88.899v6.805H218.38z",
  className: "welcome_svg__welcome-cls-14",
  "data-name": "Rectangle 330"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M218.38 302h88.899v6.805H218.38z",
  className: "welcome_svg__welcome-cls-14",
  "data-name": "Rectangle 331"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M171.69 144.16h140.855v30.578H171.69z",
  className: "welcome_svg__welcome-cls-15",
  "data-name": "Rectangle 332"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  width: 57.042,
  height: 17.549,
  className: "welcome_svg__welcome-cls-15",
  "data-name": "Rectangle 333",
  rx: 3.131,
  transform: "translate(213.6 150.67)"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  width: 57.042,
  height: 17.549,
  className: "welcome_svg__welcome-cls-13",
  "data-name": "Rectangle 334",
  rx: 3.131,
  transform: "translate(212.88 149.88)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M144.83 271.77v36.822l-2.163.216 2.163 1.964h68.6v-39l-2.163-1.964z",
  className: "welcome_svg__welcome-cls-7",
  "data-name": "Path 1236"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M142.66 269.8h68.601v39.001H142.66z",
  className: "welcome_svg__welcome-cls-18",
  "data-name": "Rectangle 335"
});

var _ref34 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1815"
}, /*#__PURE__*/React.createElement("path", {
  d: "M172.675 293.107v-.276.276h12.817a.986.986 0 00.945-.713l2.828-9.9a.983.983 0 00-.945-1.253h-17.055l-.458-2.058a.977.977 0 00-.959-.769h-4.241a.983.983 0 100 1.965h3.453l2.458 11.059a2.392 2.392 0 001.072 4.485 2.4 2.4 0 103.011.009h6.971a2.4 2.4 0 103-.016.976.976 0 00-.078-1.949h-12.818a.431.431 0 010-.863zm11.406 5.1a.431.431 0 11.431-.43.43.43 0 01-.431.433zm-9.991-.862a.431.431 0 11-.431.431.433.433 0 01.431-.428zm-2.39-14.136h15.32l-2.265 7.932h-11.29z",
  className: "welcome_svg__welcome-cls-19",
  "data-name": "Path 1239"
}));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1817"
}, /*#__PURE__*/React.createElement("path", {
  d: "M308.32 339.41H180.11l-1.6-1.487 1.6-18.174 126.61-1.487 1.6 1.487z",
  className: "welcome_svg__welcome-cls-18",
  "data-name": "Path 1240"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.52 318.26h128.206v19.661H178.52z",
  className: "welcome_svg__welcome-cls-13",
  "data-name": "Rectangle 336"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.73 318.26l1.6 1.487v19.661l-1.6-1.487z",
  className: "welcome_svg__welcome-cls-20",
  "data-name": "Path 1241"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.52 337.92h128.21l1.6 1.487H180.12z",
  className: "welcome_svg__welcome-cls-20",
  "data-name": "Path 1242"
}));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1821"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1819"
}, /*#__PURE__*/React.createElement("path", {
  d: "M372.072 188.843l-21.848-23.436a2.637 2.637 0 00-1.741-.833l-12.227-.875a2.638 2.638 0 00-2.826 2.586l-.217 12.512a2.639 2.639 0 00.708 1.845l21.823 23.414a2.637 2.637 0 003.729.131l12.463-11.616a2.639 2.639 0 00.136-3.728zm-36.3-19.516a2.088 2.088 0 112.952.1 2.088 2.088 0 01-2.948-.101z",
  className: "welcome_svg__welcome-cls-13",
  "data-name": "Path 1243"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1818"
}, /*#__PURE__*/React.createElement("path", {
  d: "M349.638 175.78c1.961-1.828 4.292-1.7 5.848-.03 1.57 1.685 1.537 4.02-.426 5.848s-4.292 1.7-5.863.014c-1.555-1.67-1.536-3.989.441-5.832zm12.431 7.325a1.318 1.318 0 01-.765 2.2l-15.413 2.35a1.318 1.318 0 01-1.161-.4 1.317 1.317 0 01.764-2.2l15.413-2.347a1.32 1.32 0 011.162.397zm-8.836-3.468c1.151-1.072 1.227-1.9.713-2.452-.484-.518-1.345-.534-2.5.54s-1.2 1.933-.713 2.452c.518.551 1.35.533 2.501-.54zm-1.481 9.134c1.96-1.827 4.277-1.714 5.848-.029s1.536 4.02-.426 5.847c-1.977 1.844-4.292 1.7-5.864.014s-1.535-3.988.443-5.832zm3.594 3.857c1.151-1.072 1.212-1.917.713-2.452s-1.345-.533-2.5.54-1.212 1.917-.713 2.452 1.351.533 2.502-.54z",
  className: "welcome_svg__welcome-cls-19",
  "data-name": "Path 1244"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1820"
}, /*#__PURE__*/React.createElement("path", {
  d: "M317.529 139.157a12.538 12.538 0 002.031 12.621c1.932 2.255 4.542 3.267 7.1 4.664a20.936 20.936 0 019.709 11.053c.318.8 1.626.451 1.3-.359a22.414 22.414 0 00-7.506-10.1c-2.5-1.839-5.538-2.763-7.949-4.708-3.98-3.211-5.081-8.04-3.384-12.808.292-.821-1.013-1.175-1.3-.36z",
  className: "welcome_svg__welcome-cls-9",
  "data-name": "Path 1245"
})));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1822"
}, /*#__PURE__*/React.createElement("path", {
  d: "M230.63 155.67h5.944v1.464h-4.213v1.917h3.693v1.448h-3.693v3.5h-1.731z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1246"
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.457 155.657h1.971l2.949 8.337h-1.888l-.55-1.714h-3.07l-.565 1.714h-1.822zm-.115 5.186h2.135l-1.053-3.281z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1247"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.691 161.422a1.686 1.686 0 00.318.853 1.846 1.846 0 001.484.514 3.2 3.2 0 001.023-.135.971.971 0 00.744-.967.712.712 0 00-.365-.639 3.937 3.937 0 00-1.157-.39l-.9-.2a5.587 5.587 0 01-1.828-.639 2.032 2.032 0 01-.843-1.8 2.4 2.4 0 01.824-1.861 3.517 3.517 0 012.422-.74 3.707 3.707 0 012.275.7 2.479 2.479 0 01.988 2.027H250a1.192 1.192 0 00-.673-1.068 2.294 2.294 0 00-1.038-.209 1.979 1.979 0 00-1.1.271.86.86 0 00-.411.758.715.715 0 00.406.668 5.067 5.067 0 001.107.345l1.463.346a3.723 3.723 0 011.441.6 2.044 2.044 0 01.745 1.7 2.39 2.39 0 01-.883 1.9 3.728 3.728 0 01-2.5.755 4.079 4.079 0 01-2.589-.743 2.461 2.461 0 01-.944-2.044z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1248"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.22 155.66v1.476h-2.494v6.861h-1.753v-6.861h-2.506v-1.476z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1249"
}));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1823"
}, /*#__PURE__*/React.createElement("path", {
  d: "M224.198 330.939a3.126 3.126 0 01-3.022 1.764H217.7v-3.721h-.78v-1.448h.78v-3.156h3.487a4.2 4.2 0 011.65.292 2.828 2.828 0 011.18.981 3.657 3.657 0 01.56 1.2 5.714 5.714 0 01.181 1.487 5.641 5.641 0 01-.56 2.601zm-3.6.317a3.953 3.953 0 001.014-.091 1.507 1.507 0 00.838-.616 2.661 2.661 0 00.423-1.033 5.631 5.631 0 00.116-1.06 2.654 2.654 0 00-.849-2.314 2.61 2.61 0 00-1.462-.328h-1.286v1.72h1.754v1.448h-1.754v2.278z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1250"
}), /*#__PURE__*/React.createElement("path", {
  d: "M228.447 324.359h1.971l2.95 8.337h-1.889l-.55-1.713h-3.07l-.565 1.713h-1.822zm2.412-1.124a2.5 2.5 0 01-2.748 0 1.76 1.76 0 01-.577-1.28h.763a.846.846 0 00.542.707 1.994 1.994 0 001.29 0 .845.845 0 00.543-.707h.763a1.76 1.76 0 01-.576 1.285zm-2.527 6.31h2.135l-1.053-3.28zm.355 3.659h1.477v1.341h-1.477z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1251"
}), /*#__PURE__*/React.createElement("path", {
  d: "M240.48 324.37v1.477h-2.494v6.86h-1.753v-6.86h-2.506v-1.477z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1252"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250.254 324.366h2.507v8.337h-1.624v-5.643q0-.243.006-.681c0-.291.006-.517.006-.676l-1.58 7h-1.693l-1.568-7c0 .158 0 .384.006.676s.006.519.006.681v5.639h-1.624v-8.337h2.535l1.518 6.555z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1253"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.371 324.366h1.77v5.12a2.905 2.905 0 00.2 1.255 1.7 1.7 0 002.744 0 2.905 2.905 0 00.2-1.255v-5.12h1.77v5.124a4.3 4.3 0 01-.411 2.069 3.848 3.848 0 01-5.868 0 4.3 4.3 0 01-.411-2.069z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1254"
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.119 324.366h1.971l2.95 8.337h-1.889l-.55-1.713h-3.069l-.566 1.713h-1.822zm-.115 5.186h2.135l-1.053-3.28z",
  className: "welcome_svg__welcome-cls-11",
  "data-name": "Path 1255"
}));

var _ref39 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1824"
}, /*#__PURE__*/React.createElement("path", {
  d: "M125.4 161.3a5.724 5.724 0 115.724-5.724 5.73 5.73 0 01-5.724 5.724zm0-9.651a3.927 3.927 0 103.928 3.927 3.932 3.932 0 00-3.928-3.928z",
  className: "welcome_svg__welcome-cls-18",
  "data-name": "Path 1256"
}));

var _ref40 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1825"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ff281f",
  d: "M135.25 187.98a5.724 5.724 0 115.723-5.724 5.73 5.73 0 01-5.723 5.724zm0-9.652a3.928 3.928 0 103.927 3.928 3.932 3.932 0 00-3.927-3.928z",
  "data-name": "Path 1257"
}));

var _ref41 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1832"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1828"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1826"
}, /*#__PURE__*/React.createElement("path", {
  d: "M131.127 204.296a.9.9 0 01-.9-.9v-3.959a.9.9 0 011.8 0v3.959a.9.9 0 01-.9.9z",
  className: "welcome_svg__welcome-cls-6",
  "data-name": "Path 1258"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1827"
}, /*#__PURE__*/React.createElement("path", {
  d: "M131.127 211.224a.9.9 0 01-.9-.9v-3.959a.9.9 0 011.8 0v3.959a.9.9 0 01-.9.9z",
  className: "welcome_svg__welcome-cls-6",
  "data-name": "Path 1259"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1831"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1829"
}, /*#__PURE__*/React.createElement("path", {
  d: "M136.687 205.781h-3.557a.9.9 0 010-1.8h3.557a.9.9 0 010 1.8z",
  className: "welcome_svg__welcome-cls-6",
  "data-name": "Path 1260"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1830"
}, /*#__PURE__*/React.createElement("path", {
  d: "M129.127 205.781h-3.556a.9.9 0 110-1.8h3.556a.9.9 0 010 1.8z",
  className: "welcome_svg__welcome-cls-6",
  "data-name": "Path 1261"
}))));

var _ref42 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1839"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1835"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1833"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.961 175.33a.9.9 0 01-.9-.9v-3.959a.9.9 0 111.8 0v3.959a.9.9 0 01-.9.9z",
  className: "welcome_svg__welcome-cls-2",
  "data-name": "Path 1262"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1834"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.961 182.26a.9.9 0 01-.9-.9v-3.959a.9.9 0 011.8 0v3.959a.9.9 0 01-.9.9z",
  className: "welcome_svg__welcome-cls-2",
  "data-name": "Path 1263"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1838"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1836"
}, /*#__PURE__*/React.createElement("path", {
  d: "M114.52 176.818h-3.557a.9.9 0 110-1.8h3.557a.9.9 0 110 1.8z",
  className: "welcome_svg__welcome-cls-2",
  "data-name": "Path 1264"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1837"
}, /*#__PURE__*/React.createElement("path", {
  d: "M106.962 176.818h-3.557a.9.9 0 010-1.8h3.557a.9.9 0 110 1.8z",
  className: "welcome_svg__welcome-cls-2",
  "data-name": "Path 1265"
}))));

var _ref43 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1841"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1840"
}, /*#__PURE__*/React.createElement("path", {
  d: "M351.34 366.365h-14.12c-1.92 0-3.622-1.714-4.215-4.245l-5.988-25.542c-.245-1.044.281-2.131 1.071-2.215a149.813 149.813 0 0132.387 0c.79.087 1.314 1.172 1.069 2.216l-5.989 25.545c-.593 2.527-2.296 4.241-4.215 4.241z",
  className: "welcome_svg__welcome-cls-13",
  "data-name": "Path 1266"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2e182c",
  d: "M360.29 336.211c0 .68-7.124 1.23-15.913 1.23s-15.913-.55-15.913-1.23 7.125-1.231 15.913-1.231 15.913.551 15.913 1.231z",
  "data-name": "Path 1267"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0571f0",
  d: "M365.422 301.693c-6.679-1.761-16.885 12.1-19.986 25.623v-19.7a40.62 40.62 0 019.922-11.313c8.388-6.831 16.108-15.6 9.417-17.36-6.271-1.651-15.65 10.468-19.339 23.143v-25.289a26.8 26.8 0 015.681-6.184c5.286-4.3 10.152-9.83 5.935-10.941-3.66-.964-9 5.514-11.616 12.822v-8.2a38.917 38.917 0 012.722-9.861c3.888-8.579 5.988-17.418.862-16.761s-8.457 15.938-5.652 27.669v4.218c-1.895-8.585-8.4-17.475-12.641-16.356-4.217 1.11.649 6.636 5.935 10.941a24.349 24.349 0 016.706 7.994v19.925c-3.039-13.585-13.318-27.608-20.033-25.84-6.692 1.763 1.029 10.53 9.417 17.361 6.339 5.162 9.332 10 10.616 12.63v23.892c-3.248-13.336-13.418-27.3-19.852-25.061-4.959 1.726-.953 8.169 8.474 15.917a44.489 44.489 0 0111.38 13.847v11.254a3.485 3.485 0 002.068 0v-4.479c1.312-2.651 4.308-7.433 10.569-12.532 8.385-6.831 16.106-15.597 9.415-17.359z",
  "data-name": "Path 1268"
})));

function SvgWelcome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 421.67 348.77"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1842",
    transform: "translate(-45.24 -56.667)"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1816"
  }, _ref32, /*#__PURE__*/React.createElement("path", {
    d: "M144.83 271.77v36.822l-2.163.216 2.163 1.964h68.6v-39l-2.163-1.964z",
    "data-name": "Path 1237",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    },
    fill: "#259aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.27 269.8l2.163 1.964v39l-2.163-1.964z",
    "data-name": "Path 1238",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    },
    fill: "#259aff",
    opacity: 0.5
  }), _ref33, _ref34), _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43));
}

export default SvgWelcome;